import { createSelector } from "reselect";
import { PcpSharedContextType } from "../slices/pcpSharedSlice";


export const selectPcpCallState = createSelector(
    (state: PcpSharedContextType) => state.pcpCallState,
    (pcpCallState) => pcpCallState
);

export const selectAcsToken = createSelector(
    (state: PcpSharedContextType) => state.acsToken,
    (acsToken) => acsToken
);

export const selectLessonId = createSelector(
    (state: PcpSharedContextType) => state.lessonId,
    (lessonId) => lessonId
);

export const selectPcpToken = createSelector(
    (state: PcpSharedContextType) => state.pcpToken,
    (pcpToken) => pcpToken
);

export const selectIsMobile = createSelector(
    (state: PcpSharedContextType) => state.isMobile,
    (isMobile) => isMobile
);

export const selectIsActiveElementFullScreen = createSelector(
    (state: PcpSharedContextType) => state.isActiveElementFullScreen,
    (isActiveElementFullScreen) => isActiveElementFullScreen
);

export const selectActiveElement = createSelector(
    (state: PcpSharedContextType) => state.activeElement,
    (activeElement) => activeElement
);

export const selectIsDesktopWithSmallHeight = createSelector(
    (state: PcpSharedContextType) => state.isDesktopWithSmallHeight,
    (isDesktopWithSmallHeight) => isDesktopWithSmallHeight
);

export const selectScreenOrientation = createSelector(
    (state: PcpSharedContextType) => state.screenOrientation,
    (screenOrientation) => screenOrientation
);

export const selectWindowSize = createSelector(
    (state: PcpSharedContextType) => state.windowSize,
    (windowSize) => windowSize
);
